'use strict';

var isForcedMotionValue = require('../../../motion/utils/is-forced-motion-value.cjs');
var isMotionValue = require('../../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue.isMotionValue(style[key]) ||
            (prevProps.style &&
                isMotionValue.isMotionValue(prevProps.style[key])) ||
            isForcedMotionValue.isForcedMotionValue(key, props) ||
            visualElement?.getValue(key)?.liveStyle !== undefined) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

exports.scrapeMotionValuesFromProps = scrapeMotionValuesFromProps;
//# sourceMappingURL=scrape-motion-values.cjs.map
